import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery, takeLatest } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TGetTotalNetValueOrQuantityReduxParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
export default function* watchGetTotalNetValueOrQuantity(api: GoldGateway): SagaWatcherReturnType {
    yield takeLatest('gold/goldGetTotalNetValueOrQuantityAttempt', handleGetTotalNetValueOrQuantity, api);
}

function* handleGetTotalNetValueOrQuantity(api: GoldGateway, action: PayloadAction<TGetTotalNetValueOrQuantityReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const transactionType = reduxState.gold.buyAndSellGold.transactionType;

    const {
        productId,
        quantity,
        totalNetValue,
        pricePerGram,
        discountId,
        index,
        baseAPIPrice,
    } = action.payload;

    const response = yield* call([api, api.getTotalNetValueOrQuantity], {
        authToken,
        productId,
        baseAPIPrice: Number(baseAPIPrice),
        pricePerGram,
        transactionType,
        quantity,
        totalNetValue,
        discountId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetTotalNetValueOrQuantityFailure(response.message || ErrorMessages.GenericError));
        if (quantity) {
            yield put(combinedActions.goldGetTotalNetValueOrQuantitySuccess({ totalNetValue: undefined, index: index || 0 }));
        }

        if (totalNetValue) {
            yield put(combinedActions.goldGetTotalNetValueOrQuantitySuccess({ quantity: undefined, index: index || 0 }));
        }
        toast.error(response.message || 'Failed get value.');
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        if (quantity) {
            yield put(combinedActions.goldGetTotalNetValueOrQuantitySuccess({ totalNetValue: response.data || undefined, index: index || 0 }));
        }

        if (totalNetValue) {
            yield put(combinedActions.goldGetTotalNetValueOrQuantitySuccess({ quantity: response.data || undefined, index: index || 0 }));
        }
    }
}
